import { CALENDAR_RANGE, CONTENT_TYPES } from "@/constants"

export const STATE_QUERY = `
	id
	name
	handle
`
export const MARGIN_QUERY = `
	id
	margin
`

export const COLUMN_START = `
	columnStart {
		columnStart 
	}
`

export const CATEGORY_QUERY = `
	id
	categoryName
	tag
	urlParameter
`
export const IMAGE_QUERY = `
	id
	url
	alt
	width
	height
	focalPoint{
	  x
	  y 
	}
	blurUpThumb
	author
	title
	copyright
`

export const IMAGE_BLOCK_QUERY = `
	image{
		${IMAGE_QUERY}
	}
	showMetaData
`
export const VIDEO_QUERY = `
	url
	height
	width
`
export const PADDINGS_QUERY = `
	paddings {
		top
		bottom
	}
`
export const COLOR_BLOCK_QUERY = `
	color
`

export const AB_VARIANT_BLOCK_QUERY = `
	abVariant
`

export const AUDIO_FILE_BLOCK_QUERY = `
	id
	source{
		url
		filename
		title
	}
`
export const SEO_QUERY = ` 
	_seoMetaTags {
		attributes
		content
		tag
	}
`

export const MODAL_CONTENT_QUERY = `
	id
	header
	icon {
		${IMAGE_QUERY}
	}
`

export const TRANSFER_QUERY = `
	id
	title
	value
	type: transferType
	helperText1
	helperText2
`
export const CONTACT_ENTITY_QUERY = `
	id
	name
	info
`

export const HEADER_AND_DESCRIPTION_BLOCK_QUERY = `
	header
	description
	animation
`
export const HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK_QUERY = `
	header
	description
	description2
	animation
`
export const STATISTIC_BLOCK_QUERY = ` 
	id
	description
	number
	noun
	displayGapBetweenNumberAndNoun 
`
export const SINGLE_DOWNLOAD_FILE_BLOCK_QUERY = `
	id
	file {
		url
		filename
	}
	fileVisibleName
`
export const STATISTIC_GROUP_BLOCK_QUERY = `
	id
	name
	items{
		${STATISTIC_BLOCK_QUERY}
	}
`

export const HEADER_DESCRIPTION_BLOCK = `
	id
	header
	description
	columnStart
`

export const RECAP_INFO_QUERY = `
	id
	headerDescription{
		${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	}
	subHeader
	listHeader
	listBoxColumnStart
	showRecap
	showTopBarRecap
	topBarRecapHeader
`

export const LOCAL_LINK_QUERY = `
	id
	label
	link {
		__typename
		... on ${CONTENT_TYPES.ALL_NEWS_PAGE} {
			id
			pageName: title
			slug
		}
		... on ${CONTENT_TYPES.NEWS} {
			id
			pageName: title
			slug
		}
		... on ${CONTENT_TYPES.SINGLE_PAGE} {
			id
			slug
			pageName: singlePageName
			pageType
		}
		... on ${CONTENT_TYPES.WHAT_WE_DO_CATEGORY} {
			id
			slug
			pageName
		}
		... on ${CONTENT_TYPES.WHAT_WE_DO_SINGLE_ACTION} {
			id
			slug
			pageName: name
		}
		... on ${CONTENT_TYPES.BE_WITH_US_PAGE} {
			id
			slug
			pageName
		}
		... on ${CONTENT_TYPES.DESCRIPTION_WITH_IMAGE} {
            id
            title
            isBeWithUsPage
        }
        ... on ${CONTENT_TYPES.SINGLE_PAYMENT} {
			id
		}
		... on ${CONTENT_TYPES.ANNOUNCEMENTS_AND_TENDERS_YEARS} {
			id
			slug
		}
		... on ${CONTENT_TYPES.SINGLE_BE_WITH_US_PAGE} {
			id
			slug
			category {
				id
				slug 
			}
		}
		... on ${CONTENT_TYPES.PRODUCT_PAGE} {
			id
			pageName
			slug
		}
		... on ${CONTENT_TYPES.FACT_PAGE} {
			id
			pageName
			slug
		}
	}
`

export const SCROLL_LINK_QUERY = `
	id
	label
	link {
		... on ${CONTENT_TYPES.CONTACT_FORM_PREVIEW} {
			id
		}
	} 
`

export const EXTERNAL_LINK_QUERY = `
	url
	newCard
	label
`

export const UNIVERSAL_LINK_QUERY = `
	text
	link {
		__typename
		... on ${CONTENT_TYPES.LOCAL_LINK}{
			${LOCAL_LINK_QUERY}
		}
		... on ${CONTENT_TYPES.EXTERNAL_LINK}{
			${EXTERNAL_LINK_QUERY}
		}
		... on ${CONTENT_TYPES.SCROLL_LINK_RECORD} {
			${SCROLL_LINK_QUERY}
		}
	}
`

export const BUTTON_BLOCK_QUERY = ` 
	id
	link {
		${UNIVERSAL_LINK_QUERY}
	}
`
export const VIDEO_BLOCK_QUERY = ` 
	id
	externalVideoUrl {
		${VIDEO_QUERY}
	}
	video {
		${VIDEO_QUERY}
	}
	cover{
		${IMAGE_BLOCK_QUERY}
	}
	width
`
export const SIMPLE_CARD_BLOCK_QUERY = `
	id
	header
	description
	cover{
	  ${IMAGE_QUERY}
	}
`
export const CARD_BLOCK_QUERY = `
	id
	header
	description
	supportHeader
	cover{
	  ${IMAGE_QUERY}
	}
	backgroundColor {
		hex
	}
	isHighlighted
	shouldCoverTakeFullSpace
`

export const VARIANT_CARD_QUERY = `
	id
	variant
	card{
	  ${SIMPLE_CARD_BLOCK_QUERY}
	}
`
export const SEE_ALSO_INFO_BLOCK_QUERY = `
	header
  	variant
`

export const WHAT_WE_DO_SINGLE_ACTION_QUERY = `
	  __typename
      id
      slug
      ${AB_VARIANT_BLOCK_QUERY}
      card{
      	${CARD_BLOCK_QUERY}
      }
      active
      categories {
      	id
        slug
      }
`

export const SINGLE_FACT_QUERY = `
	__typename
	id
	pageName
	slug
	bannerHeader
	bannerImage {
		${IMAGE_QUERY} 
	}
	previousFact {
		__typename
		slug
	}
	nextFact {
		__typename
		slug
	}
	number
	card {
		${SIMPLE_CARD_BLOCK_QUERY}
	}
`

export const SINGLE_PRODUCT_QUERY = `
	__typename
	id
	pageName
	slug
	bannerHeader
	bannerImage {
		${IMAGE_QUERY} 
	}
	card {
		${SIMPLE_CARD_BLOCK_QUERY}
	}
`

export const WHAT_WE_DO_CATEGORY_QUERY = `
	__typename
	id
	slug
	active
	order
	${AB_VARIANT_BLOCK_QUERY}
	card {
		${CARD_BLOCK_QUERY}
	}
`

export const TABLE_BLOCK_QUERY = `
	id
	tableContent
	size
`

export const SINGLE_BE_WITH_US_PAGE_QUERY = `
	__typename
	id
	slug
	category {
		slug
	}
	card {
		${CARD_BLOCK_QUERY}
	}
`

export const DESCRIPTION_WITH_IMAGE_QUERY = `
	... on ${CONTENT_TYPES.DESCRIPTION_WITH_IMAGE} {
		id
		header
		description
		image {
			${IMAGE_QUERY}
		}
		shouldDisplayItemsInHighlightGrid
		isHorizontalAspect
		${PADDINGS_QUERY}
		pages {
			__typename
			... on ${CONTENT_TYPES.WHAT_WE_DO_CATEGORY} {
				${WHAT_WE_DO_CATEGORY_QUERY}
			}
			... on ${CONTENT_TYPES.SINGLE_BE_WITH_US_PAGE} {
				${SINGLE_BE_WITH_US_PAGE_QUERY}
			}
		}
		firstButton {
			${BUTTON_BLOCK_QUERY}	
		}
		secondButton {
			${BUTTON_BLOCK_QUERY}	
		}
	} 
`

export const DONOR_QUERY = `
      id
	  fullName
	  motto
	  story
	  age
	  image{ 
	  	${IMAGE_QUERY}
	  }
	  state{
	  	${STATE_QUERY}
	  }
`
export const IMAGE_WITH_CAPTION_QUERY = ` 
	id
	width
	caption
	${PADDINGS_QUERY}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	image {
		image {
			${IMAGE_QUERY}
		}
	}
`

export const HISTORY_SECTION_QUERY = `
	id
	items{
		__typename
		... on ${CONTENT_TYPES.VARIANT_CARD}{
			${VARIANT_CARD_QUERY}
		}
		... on ${CONTENT_TYPES.PLACEHOLDER}{
			id 
		}
	}
`

export const SINGLE_EXPANDABLE_VIDEO = `
	  __typename
      id
	  videoUrl{
        url
      }
	  state{
	  	${STATE_QUERY}
	  }
`

export const SINGLE_NEWS_QUERY = `
	id
	_createdAt
	state: chooseState {
		${STATE_QUERY}
	}
	slug
	title
	card{
		${CARD_BLOCK_QUERY}
	}
`

export const TABS_AND_IMAGE_QUERY = `
	id
	title
	state {
		${STATE_QUERY}
	}
	tabs {
		id
		title
		description
		contentImage {
			url
			alt
			width
			height
		}
		bigImage {
			url
			alt
			width
			height
		}
	}
`

export const WHAT_WE_DO_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.WHAT_WE_DO_PREVIEW} {
		id
		headerDescription{
		  ${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
		}
		button {
		  ${BUTTON_BLOCK_QUERY}
		}
		${PADDINGS_QUERY}
	    actions: _allReferencingWhatWeDoSingleActions(orderBy: order_DESC){
		  ${WHAT_WE_DO_SINGLE_ACTION_QUERY}
		   state: chooseState{
			${STATE_QUERY}
		  }
		  order
		}
		categories: _allReferencingWhatWeDoCategories(orderBy: order_DESC){
			${WHAT_WE_DO_CATEGORY_QUERY}
			order
		}
	} 
`
export const PARALLAX_IMAGE_AND_DESCRIPTION_QUERY = `
	id
	variant
	headerDescription{
	  ${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	}
	image{
		image{
			${IMAGE_QUERY}
		}
	}
	${PADDINGS_QUERY}
`
export const EXPANDING_LIST_AND_DESCRIPTION_QUERY = `
	id
	headerDescription{
	  ${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	}
	moreText
	lessText
	list{
	  id
	  header
	  description
	}
	${PADDINGS_QUERY}
`
export const PARALLAX_SLIDER_QUERY = `
	id
	button {
		${BUTTON_BLOCK_QUERY}
	}
	header
	slides{
		id
		title
		backgroundColor{
			${COLOR_BLOCK_QUERY}
		}
		description
		assetVariant
		thumbnail{
			image{
			  ${IMAGE_QUERY}
			}
		}
	}
	${PADDINGS_QUERY}
`

export const DONOR_STORIES_QUERY = `
	... on ${CONTENT_TYPES.DONOR_STORIES} {
		id
		hidden
		headerDescription{
		  ${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
		}
		button{
			${BUTTON_BLOCK_QUERY}
		}
		${PADDINGS_QUERY}
		donors: _allReferencingDonors {
		  ${DONOR_QUERY}
		}	
	} 
`

export const HEADING_GRAPHIC_MODULE = `
	id
	heading
	image {
		__typename
		... on ${CONTENT_TYPES.IMAGE} {
			image {
				${IMAGE_QUERY}
			}
		}
	}
	button {
		${BUTTON_BLOCK_QUERY}
	}
	${PADDINGS_QUERY}
`

export const BRANCH_NAVIGATOR_QUERY = `
	id
	headerDescription{
	  ${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	}
	mapDescription
    hqHeader
    contactHeader
    bankAccountHeader
    isTextileCollectionMap
	${PADDINGS_QUERY}
`

export const EXPANDABLE_VIDEO_QUERY = `
	... on ${CONTENT_TYPES.EXPANDABLE_VIDEO} {
		id
		${PADDINGS_QUERY}
		video: _allReferencingExpandableVideos {
		  ${SINGLE_EXPANDABLE_VIDEO}
		}	
	} 
`

export const NEWS_THUMBNAIL_HOME = `
	... on ${CONTENT_TYPES.NEWS_THUMBNAIL} {
		id
		header
		buttonText
		buttonLink {
			slug
		}
		${PADDINGS_QUERY}
	}
`

export const STATES_MAP_QUERY = `
	... on ${CONTENT_TYPES.STATES_MAP} {
		id
        header
        description
        aboveSelectText
        button {
        	${BUTTON_BLOCK_QUERY}
        }
		${PADDINGS_QUERY}
	}
`

export const RULES_TILES = `
	... on ${CONTENT_TYPES.RULES_TILES} {
        header
        button {
            ${BUTTON_BLOCK_QUERY}
        }
		${PADDINGS_QUERY}
        rules {
            __typename
            ... on TileBigRecord {
                text
            }
            ... on TileIconTextRecord {
                text
                icon {
                    ${IMAGE_QUERY}
                }
                iconHover {
                	${IMAGE_QUERY}
                }
                description
                isbigonhover
            }
        }
	}
`

const PAYMENT_QUERY = `
	id
	paymentName
	paymentId
	description
	inflectedWord
	image {
		${IMAGE_QUERY}
	}
	showMonthlyInfoModal
	showMonthlyPaymentTab
	setMonthlyPaymentTabToDefault
	actionButton {
		${BUTTON_BLOCK_QUERY}
	}
	amountTabs {
	  amountWithoutUnit
	  pictogram {
		url
		alt
	  }
	  description
	}
	amountTabsMonthly {
	  amountWithoutUnit
	  pictogram {
		url
		alt
	  }
	  description
	}
	payuPaymentId
	payuSecondKey
	payuAuthorization
	payuRecurringPaymentAuthorization
	payuRecurringPaymentSecondKey
	payuRecurringPaymentOauth
	paypalId
	stripeId
`
export const PAYMENT_MODULE_QUERY = `
	... on ${CONTENT_TYPES.PAYMENT_MODULE} {
		id
		globalPckPayment {
			linkToGlobalPckPayment {
				${PAYMENT_QUERY}
			}
			globalPaymentRightBlocks {
				__typename
				... on ${CONTENT_TYPES.GLOBAL_PAYMENT_RIGHT_IMAGE_TEXT_LINK_BLOCK} {
					id
					text
					image {
						${IMAGE_QUERY}
					}
					blendOpacity	
					link {
						${LOCAL_LINK_QUERY}
					}
				}
				... on ${CONTENT_TYPES.GLOBAL_PAYMENT_RIGHT_IMAGE_TEXT_ACCOUNT_BLOCK} {
					id
					text
					image {
						${IMAGE_QUERY}
					}
					blendOpacity
				}
				... on ${CONTENT_TYPES.GLOBAL_PAYMENT_BANNER_KRS} {
					id
				}
			}	
        	moduleText
        }
		paymentModuleType {
			__typename
			... on ${CONTENT_TYPES.PAYMENT_WITH_STEPS_SINGLE_OR_MULTIPLE_BLOCK} {
				id
				choosePayment {
					${PAYMENT_QUERY}
				}
			}
			... on ${CONTENT_TYPES.PAYMENT_NO_RIGHT_SIDE_IMAGE} {
				id
				choosePayment {
					${PAYMENT_QUERY}
				}
			}
			... on ${CONTENT_TYPES.PAYMENT_SINGLE_WITH_HEADING_BLOCK} {
				id
				heading
				choosePayment {
					${PAYMENT_QUERY}
				}
			}
		}
		${PADDINGS_QUERY}
	} 
`

export const SUB_PAGE_BANNER_QUERY = `
	__typename
	id
	title
	header
	description

	image { 
		${IMAGE_QUERY}
	}
	imageVertical {
		${IMAGE_QUERY}
	}
	variant {
		variant
	}
	secondButton {
		${BUTTON_BLOCK_QUERY}
	}
	firstButton {
		${BUTTON_BLOCK_QUERY}
	}
	video {
		${VIDEO_QUERY}
	}
	externalVideo { 
		${VIDEO_QUERY}
	}
	videoThumbnailCover {
		${IMAGE_QUERY}
	}
	videoThumbnailDescription
	selectPaymentModule {
		__typename
		${PAYMENT_QUERY}
	} 
`

export const GLOBAL_BASED_BANNER_QUERY = `
	... on ${CONTENT_TYPES.GLOBAL_BASED_BANNER} {
		${SUB_PAGE_BANNER_QUERY}
	}
`
export const DRAGGABLE_LETTERS_BANNER_QUERY = `
	... on DraggableLettersBannerRecord {
		title
		buttonText
		scrollTo {
          id
        }
	}
`

export const CONTEXT_BASED_BANNER_QUERY = `
	contextBasedBanners: _allReferencingContextBasedBanners {
		state: chooseState {
			${STATE_QUERY}
		}
		assignTo {
			... on ${CONTENT_TYPES.WHAT_WE_DO_SINGLE_ACTION} {
				title
				active
			}
		}
		${SUB_PAGE_BANNER_QUERY}
	}	
`

export const TABS_AND_IMAGE_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.TABS_AND_IMAGE} {
		id
		${PADDINGS_QUERY}
		tabsAndImage: _allReferencingTabsAndImageModules {
		  ${TABS_AND_IMAGE_QUERY}
		}
	} 
`

export const TEXT_AND_DESCRIPTION_WITH_BUTTON_QUERY = `
	... on ${CONTENT_TYPES.TEXT_AND_DESCRIPTION_WITH_BUTTON} {
		id
		${PADDINGS_QUERY}
		title
		leftSideContent {
			${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
		}
		text
		button {
			${BUTTON_BLOCK_QUERY}
		}
	} 
`

export const FORM_INPUT_QUERY = `
	id
	name
	placeholder
	inputType 
	errorText
	required
	selectOptionsChannel {
		id
		label
		value
  	}
`

export const CONTACT_FORM_MODULE_QUERY = `
	... on ${CONTENT_TYPES.CONTACT_FORM} {
		id
        title
		${PADDINGS_QUERY}
		headerDescription {
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
				${HEADER_DESCRIPTION_BLOCK}
			}
		} 
        submitButtonText
        stateSelectHeader
        contactHeader
        addressHeader
        mobileHeading
        useGlobalContext
		state {
			${STATE_QUERY}
		}
        formInputs {
			${FORM_INPUT_QUERY}
		}
	}
`

export const CONTACT_FORM_PREVIEW_MODULE_QUERY = `
	... on ${CONTENT_TYPES.CONTACT_FORM_PREVIEW} {
		id
		formModules: _allReferencingContactFormModules {
			${CONTACT_FORM_MODULE_QUERY}
		}
	}	
`

export const BANNER_MODULE = `
	id
	state {
		${STATE_QUERY}
	}
	assetDesktop {
		${IMAGE_QUERY}
	}
	assetTablet {
		${IMAGE_QUERY}
	}
	assetMobile {
		${IMAGE_QUERY}
	}
	useGlobalContext
	link {
		${UNIVERSAL_LINK_QUERY}
	}
`

export const BANNER_MODULE_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.BANNER_MODULE_PREVIEW} {
		id
		bannerModules: _allReferencingBannerModules {
			${BANNER_MODULE}
		}
	}
`

export const SIGNUP_FORM_QUERY = `
	id
	title
	submitButtonText
	inputs {
		${FORM_INPUT_QUERY}
	}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	} 
`

export const FAQ_QUERY = `
	id
	state {
		${STATE_QUERY}
	}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	question {
		question
		answer
	}  
`

export const FAQ_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.FAQ_PREVIEW} {
		id
		useGlobalContext
		${PADDINGS_QUERY}
		faqs: _allReferencingFaqs {
		  ${FAQ_QUERY}
		}	
	} 
`

export const HEADER_DESCRIPTION_AUDIO_BLOCK_QUERY = `
	id
	header
	description
	animation
	audio{
		${AUDIO_FILE_BLOCK_QUERY}
  	}
`
export const HEADER_DESCRIPTION_IMAGE_BLOCK_QUERY = `
	id
	header
	description
	animation
	image {
		image {
			${IMAGE_QUERY}
		}
	}
`
export const HEADER_DESCRIPTION_SPOT_IMAGE_BLOCK_QUERY = `
	id
	header
	description
	animation
	spotImage {
		${IMAGE_QUERY}
	}
	graphic {
		url
	}
	secondHeader
`

export const HEADER_DESCRIPTION_ICONS_GRID_BLOCK_QUERY = `
	id
	header
	description
	animation
`

export const BULLET_POINTS_WITH_ACTIONS_SINGLE_ITEM_QUERY = `
	id
	header
	description
	action
`
export const BRANCH_UNIT_QUERY = `
	id
	name
	category
	street
    city
    postalCode
    email
    phone
	geolocation{
		latitude
		longitude
	}
`

export const BULLET_POINTS_WITH_ACTIONS_BLOCK_QUERY = `
	id
	items {
		__typename
		... on ${CONTENT_TYPES.BULLET_POINTS_WITH_ACTIONS_SINGLE_ITEM_BLOCK} {
			${BULLET_POINTS_WITH_ACTIONS_SINGLE_ITEM_QUERY}
		}
	}
`

export const STRUCTURED_TEXT_QUERY = `
		__typename
		value
		blocks {
			__typename
			... on ${CONTENT_TYPES.MARGIN} {
				id
				${MARGIN_QUERY}
			}
			... on ${CONTENT_TYPES.IMAGE}  {
				id
				image {
					${IMAGE_QUERY}
				}
			}
			... on ${CONTENT_TYPES.MEDIUM_IMAGE} {
				id
				image {
					${IMAGE_QUERY}
				}
			}
			... on ${CONTENT_TYPES.LARGE_IMAGE} {
				id
				image {
					${IMAGE_QUERY}
				}
			}
			... on ${CONTENT_TYPES.HIGHLIGHTED_HEADING_AND_DESCRIPTION} {
				id
				header
				description
				backgroundColor {
					${COLOR_BLOCK_QUERY}
				}
			}
			... on ${CONTENT_TYPES.VIDEO} {
				${VIDEO_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK}{
				id
				${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_TIGHT_BLOCK}{
				id
				${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK}{
				id
				${HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_AUDIO_BLOCK} {
				${HEADER_DESCRIPTION_AUDIO_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.BUTTON}{
				${BUTTON_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.ARROW_BUTTON}{
				${BUTTON_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.ASSET_BLOCK} {
				id
				text
				asset {
					id
					url
				}
			}
			... on ${CONTENT_TYPES.TABLE_BLOCK} {
				${TABLE_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.BULLET_POINTS_WITH_ACTIONS_BLOCK} {
				${BULLET_POINTS_WITH_ACTIONS_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.COOKIES_BUTTON_BLOCK} {
				id
				text
			}
			... on ${CONTENT_TYPES.CANCEL_SUBSCRIPTION_BUTTON_BLOCK} {
				id
				text
			}
		}
`

export const STRUCTURED_TEXT_MODULE_QUERY = `
	... on ${CONTENT_TYPES.STRUCTURED_TEXT_MODULE} {
		id
		${PADDINGS_QUERY}
		content {
			${STRUCTURED_TEXT_QUERY}
		}
	}
`

export const SOCIAL_MEDIA_FEED_QUERY = `
	... on ${CONTENT_TYPES.SOCIAL_MEDIA_FEED} {
		id
		${PADDINGS_QUERY}
		header
		text
	} 
`

export const BANNER_CALL_TO_ACTION_QUERY = `
	id
	title
	state {
		${STATE_QUERY}
	}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	header
	description
	variant
	button {
		${BUTTON_BLOCK_QUERY}
	}
	payment {
		id
	}
	${PADDINGS_QUERY} 
`

export const BANNER_CALL_TO_ACTION_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE_PREVIEW} {
		id
		title
		banners: _allReferencingBannerCallToActions {
			${BANNER_CALL_TO_ACTION_QUERY}
		}
	}
`

export const PCK_TEAM_MEMBER_QUERY = `
	id
	icon {
		${IMAGE_QUERY}
	}
	image {
		${IMAGE_QUERY} 
	}
	verticalImage {
		${IMAGE_QUERY} 
	}
	nameAndSurname
	role
	phoneNumber
	email
	gender
`

export const PCK_PARTNER_QUERY = `
	id
	title
	logo {
		${IMAGE_QUERY}
	}
	name
	description
	websiteUrl
	sliderBackgroundVariant
`

export const WHO_HELPS_TILES_QUERY = `
	id
	indent
	teamMemberTitle
	partnerTitle
	backgroundColor {
		color
	}
	memberIcon {
		${IMAGE_QUERY}	
	}
	teamMembers {
		${PCK_TEAM_MEMBER_QUERY}
	}
	partners {
		... on ${CONTENT_TYPES.TILES_BLOCK_WHO_HELP_PARTNER_BLOCK} {
			id
			partner {
				${PCK_PARTNER_QUERY} 
			}
			button {
				${BUTTON_BLOCK_QUERY}
			}
			sizeVariant
		}
	}
`

export const TEAM_QUERY = `
	... on ${CONTENT_TYPES.TEAM_MODULE} {
		id
		sections {
			id
			header
			items {
				${PCK_TEAM_MEMBER_QUERY}
			}
		}
		${PADDINGS_QUERY}
	}
`

export const TABLE_QUERY = `
	__typename
	id
	state {
		${STATE_QUERY}
	}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	tableHeader
	tableContent
	${COLUMN_START}
	${PADDINGS_QUERY}
`

export const TABLE_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.TABLE_PREVIEW_MODULE} {
		__typename
		id
		title
		tableModules: _allReferencingTableModules {
			${TABLE_QUERY}
		} 
	}
`

export const HEADER_DESCRIPTION_BOX_QUERY = `
	id
	boxText
	boxVariant
	${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
`

export const HEADER_AND_DESCRIPTION_FILES_BLOCK_QUERY = `
	id
	${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	files {
		id
		downloadFilesBlocks {
			${SINGLE_DOWNLOAD_FILE_BLOCK_QUERY}
		}
	}
`

export const HEADER_DESCRIPTION_BUTTON_QUERY = `
	id
	${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	button {
		${BUTTON_BLOCK_QUERY}
	}
`

export const HEADER_AND_DESCRIPTION_MODULE_QUERY = `
	... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_MODULE} { 
		state {
			${STATE_QUERY}
		}
		headerDescription{
			__typename
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK}{
				${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK}{
				${HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BOX} {
				${HEADER_DESCRIPTION_BOX_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_AUDIO_BLOCK} {
				${HEADER_DESCRIPTION_AUDIO_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_IMAGE_BLOCK} {
				${HEADER_DESCRIPTION_IMAGE_BLOCK_QUERY}
			}						
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_SPOT_IMAGE_BLOCK} {
				${HEADER_DESCRIPTION_SPOT_IMAGE_BLOCK_QUERY}
			}						
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_ICONS_GRID_BLOCK} {
				${HEADER_DESCRIPTION_ICONS_GRID_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_FILES_BLOCK} {
				${HEADER_AND_DESCRIPTION_FILES_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BUTTON} {
				${HEADER_DESCRIPTION_BUTTON_QUERY}
			}
		}
		columnStart
		${PADDINGS_QUERY}
	}
`

export const PARTNERS_QUERY = `
	... on ${CONTENT_TYPES.PARTNERS} {
		id
		title
		variant
		animatedVariantBackground
		headerDescription {
			... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
				${HEADER_DESCRIPTION_BLOCK}
			}
		}
		header
		description
		button {
			${BUTTON_BLOCK_QUERY}
		}
		partners {
			${PCK_PARTNER_QUERY}
		}
		${PADDINGS_QUERY}
	}
`

export const GALLERY_MODULE_QUERY = `
	id
	${PADDINGS_QUERY}
	state {
		${STATE_QUERY}
	}
	assets {
		... on ${CONTENT_TYPES.GALLERY} {
			images {
				${IMAGE_QUERY}
				customData
			}
		}
	}
`

export const GALLERY_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.GALLERY_PREVIEW_MODULE} {
		id
		${PADDINGS_QUERY}
		galleries: _allReferencingGalleryModules {
		  ${GALLERY_MODULE_QUERY}
		}	
	} 
`

export const HEADER_DESCRIPTION_MODULE_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.HEADER_DESCRIPTION_PREVIEW_MODULE} {
		id
		${PADDINGS_QUERY}
		allHeaderDescription: _allReferencingHeaderDescriptionModules {
		  ${HEADER_AND_DESCRIPTION_MODULE_QUERY}
		}	
	} 
`

export const HIGHLIGHTED_HEADING_QUERY = `
	id
	state {
		${STATE_QUERY}
	}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	highlightedHeadingBlock {
		id
		content
		button {
			${BUTTON_BLOCK_QUERY}
		}
		variant
		sizeVariant
		${PADDINGS_QUERY}
	}
`

export const HIGHLIGHTED_HEADING_BLOCK_QUERY = `
	id
	content
	button {
		${BUTTON_BLOCK_QUERY}
	}
	variant
	sizeVariant
	${PADDINGS_QUERY}
`

export const FILE_TILE_QUERY = `
	id
	title
	description
	downloadAsset {
		id
		url
	}
	coverImage {
		${IMAGE_QUERY}
	}
	border
	bigHeader
`

export const TILES_MODULE_QUERY = `
	id
	title
	${PADDINGS_QUERY}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	variant {
		__typename
		... on ${CONTENT_TYPES.TILES_BLOCK_SIMPLE} {
			id
			tiles {
				id
				text
				variant
			} 
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_BE_WITH_US_TILE} {
			id
			beWithUsRows {
				columnStart
				beWithUsLinks {
					${SINGLE_BE_WITH_US_PAGE_QUERY}
				}
			    whiteTileHeader
			    whiteTileDescription
			    button {
			    	${BUTTON_BLOCK_QUERY}
			    }
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_IMAGE_HEADER_DESCRIPTION} {
			id
			tiles {
				${CARD_BLOCK_QUERY}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_FILE} {
			id
			tiles {
				${FILE_TILE_QUERY}
			}			
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_WHO_HELP} {
			${WHO_HELPS_TILES_QUERY}
		}		
		... on ${CONTENT_TYPES.TILES_BLOCK_RECTANGLE_GRID} {
			id
			heading
			backgroundColor {
				${COLOR_BLOCK_QUERY}
			}
			tiles {
				id
				icon {
					${IMAGE_QUERY}
				}
				content
			}
		}			
		... on ${CONTENT_TYPES.TILES_BLOCK_RECTANGLE_GRID_ADDITIONAL_TOP_SECTION} {
			id
			topHeading
			topDescription
			topIcon {
				url
			}
			heading
			tiles {
				id
				text
				title
			}
		}		
		... on ${CONTENT_TYPES.TILES_BLOCK_IMAGE_HEADER_TEXT_BUTTON} {
			id
			heading
			description
			backgroundColor {
				${COLOR_BLOCK_QUERY}
			}
			image {
				image {
					${IMAGE_QUERY}
				}
			}
			button {
				${BUTTON_BLOCK_QUERY}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_HOW_WE_HELP} {
			id
			backgroundColor {
				${COLOR_BLOCK_QUERY}
			}
			variant
			tiles {
				id
				icon {
					${IMAGE_QUERY}
				}
				content
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_HEADER_DESCRIPTION_IRREGULAR} {
			id
			rows {
				id
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_HEADER_DESCRIPTION_IRREGULAR_ROW} {
					id
					tiles {
						id
						header
						description
						sizeVariant
						colorVariant
					}
				}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_MANAGEMENT} {
			id
			lastTileLink {
				${LOCAL_LINK_QUERY}
			}
			tiles {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_MANAGEMENT_TILE} {
					id
					header
					title
					description
					image {
						image {
							${IMAGE_QUERY}
						} 
					}
				}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_LOGO} {
			id
			indent
			tiles {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_LOGO_TILE} {
					id 
					coverSize
					header
					description
					image {
						${IMAGE_QUERY}
					}
					link {
						__typename
						... on ${CONTENT_TYPES.LOCAL_LINK} {
							${LOCAL_LINK_QUERY}
						}
						... on ${CONTENT_TYPES.EXTERNAL_LINK} {
							${EXTERNAL_LINK_QUERY}
						}
					}
				}
			}			
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_CONTACT_CARD} {
			id
			tiles {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_CONTACT_CARD_TILE} {
					id
					sectionHeader
					member {
						${PCK_TEAM_MEMBER_QUERY}
					}
				}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_SQUARES_GRID_BACKGROUND} {
			id
			tiles {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_SQUARES_GRID_BACKGROUND_TILE} {
					id
					header
					asset {
						${IMAGE_QUERY}
					}
					info
				}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_IMAGES_NAVIGATION} {
			id
			tiles {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_IMAGES_NAVIGATION_TILE} {
					id
					header
					description
					image {
						image {
							${IMAGE_QUERY}
						}
					}
					button {
						${BUTTON_BLOCK_QUERY}
					}
					cornerBadges {
						__typename
						... on ${CONTENT_TYPES.TILES_BLOCK_IMAGES_NAVIGATION_TILE_CORNER_BADGE} {
							id
							header
							description
						}
					}					
				}
			}
		}
		... on ${CONTENT_TYPES.TILES_BLOCK_CONTACT_CARDS_SIMPLE} {
			id
			tiles {
				id
				header
				items {
					id
					header
					content				
				}
			}
		}
	}
`

export const TILES_MODULE_PREVIEW_QUERY = `
	... on ${CONTENT_TYPES.TILES_MODULE_PREVIEW} {
		id
		${PADDINGS_QUERY}
		allTilesModules: _allReferencingTilesModules {
		  	id
			title
			${PADDINGS_QUERY}
			headerDescription {
				... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
					${HEADER_DESCRIPTION_BLOCK}
				}
			}
			variant {
				__typename
				... on ${CONTENT_TYPES.TILES_BLOCK_FILE} {
					id
					tiles {
							id
						title
						description
						coverImage {
							${IMAGE_QUERY}
						}
			
					}			
				}
			}
			state {
				${STATE_QUERY}
			}
		}	
	} 
`

export const PINNED_HISTORY_QUERY = `
	id
	title
	elevator
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	items {
		... on ${CONTENT_TYPES.HISTORY_ITEM} {
			__typename
			id
			date
			description
			item { 
				__typename
				... on ${CONTENT_TYPES.VARIANT_IMAGE} {
					id
					variant
					image {
						image {
							${IMAGE_QUERY}
						}
					} 
				}
				... on ${CONTENT_TYPES.HISTORY_SECTION} {
					${HISTORY_SECTION_QUERY}
				}
				... on ${CONTENT_TYPES.GALLERY} {
					id
					images {
						${IMAGE_QUERY}
						customData
					}
				}
			}
		}
		... on ${CONTENT_TYPES.HIGHLIGHTED_HEADING_BLOCK} {
			__typename
			${HIGHLIGHTED_HEADING_BLOCK_QUERY}
		}
	}
	${PADDINGS_QUERY}
`

export const VIDEO_WITH_COVER_MODULE_QUERY = `
	id
	video{
		${VIDEO_BLOCK_QUERY}
	}
`
export const COLORFUL_SQUARES_MODULE_QUERY = `
	id
	squares{
		id
		header
		description
		animation
		color{
			${COLOR_BLOCK_QUERY}
		}
	}
	${PADDINGS_QUERY}
`

export const DOWNLOAD_FILES_QUERY = `
	id
	downloadFilesBlocks {
		${SINGLE_DOWNLOAD_FILE_BLOCK_QUERY}
	}
`
export const GALLERY_DESCRIPTION_TEXT_MODULE_QUERY = `
	id
	title
	${PADDINGS_QUERY}
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	items {
		__typename
		... on ${CONTENT_TYPES.GALLERY_DESCRIPTION_TEXT_ITEM_BLOCK} {
			id
			header
			description
			image {
				image {
					${IMAGE_QUERY}
				}
			}
		}
	}
`

const ARCHIVE_ITEM_CONTEXT_BLOCK_QUERY = `
	layout
	description{
		value
		blocks {
			__typename
			... on ${CONTENT_TYPES.AUDIO_FILE} {
				${AUDIO_FILE_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.DOWNLOAD_FILES} {
				${DOWNLOAD_FILES_QUERY}
			}
			... on ${CONTENT_TYPES.BUTTON} {
				${BUTTON_BLOCK_QUERY}
			}
		}
	}
	cover{
		${IMAGE_BLOCK_QUERY}
	}
`

export const ARCHIVE_QUERY = `
	id
	${PADDINGS_QUERY}
	leftSideText
	timeSpans {
		id
		date
	 	context{ 
			${ARCHIVE_ITEM_CONTEXT_BLOCK_QUERY}
	 	}
		years{
			date
			context{
				${ARCHIVE_ITEM_CONTEXT_BLOCK_QUERY}
			}
		}
	}
`

export const PRESS_ACTION_QUERY = `
	id
	date
	name
	description
	media{
		logo{
			${IMAGE_QUERY}
		}
	}
	button{
		text
        content{
          __typename
          ... on ${CONTENT_TYPES.AUDIO_FILE}{
          	${AUDIO_FILE_BLOCK_QUERY}
          }
          ... on ${CONTENT_TYPES.VIDEO}{
          	${VIDEO_BLOCK_QUERY}
          }
          ... on ${CONTENT_TYPES.EXTERNAL_LINK}{
          	${EXTERNAL_LINK_QUERY}
          }
          ... on ${CONTENT_TYPES.SINGLE_DOWNLOAD_FILE_BLOCK}{
          	${SINGLE_DOWNLOAD_FILE_BLOCK_QUERY}
          }
        }
	}
`

export const PRESS_MEDIA_FEED_QUERY = `
	id
	headerDescription{
		${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
	}
	initialActions: _allReferencingPressActions(first: 8, orderBy: date_DESC){
		date
		${PRESS_ACTION_QUERY}
    }
    initialActionsMeta: _allReferencingPressActionsMeta{
      count
    }
	${PADDINGS_QUERY}
`

export const EXPANDING_TABS_MODULE_QUERY = `
	... on ${CONTENT_TYPES.EXPANDING_TABS_MODULE} {
		id
		title
		${PADDINGS_QUERY}
		headerDescription{
			${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
		}
		tabs{
			__typename
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK}{
				id
				${HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK_QUERY}
			}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK}{
				id
				${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
			}
		}
	} 
`

export const TWO_IMAGES_IN_ROW_QUERY = `
	id
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	leftImage {
		image {
			${IMAGE_QUERY}
		}
	}
	rightImage {
		image {
			${IMAGE_QUERY}
		}
	}
	variant
	${PADDINGS_QUERY}
`

export const KRS_BANNER_QUERY = `
	id
	krsTitle
	krsValue
	krsHelperText1
	krsHelperText2
	krsLink {
		${UNIVERSAL_LINK_QUERY}
	}
	krsRedButtonText
`

export const COUNT_DOWN_TIMER_MODULE_QUERY = `
	header
	description
	date
	${PADDINGS_QUERY}
`

export const SHARE_MODULE_QUERY = `
	id
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	${PADDINGS_QUERY}
	shareTitle
	shareDescription
`

export const RECAP_SUMMARY_ITEM_QUERY = `
	... on ${CONTENT_TYPES.RECAP_SUMMARY_ITEM} {
		id
		recap{
			header
			subHeader
          	inRecap
          	topBarRecapHeader
		}
		item {
			__typename 
			${PAYMENT_MODULE_QUERY}
			... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_MODULE} {
				headerDescription{
					__typename
					... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK}{
						${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
					}
					... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK}{
						${HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK_QUERY}
					}
					... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BOX} {
						${HEADER_DESCRIPTION_BOX_QUERY}
					}
					... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_AUDIO_BLOCK} {
						${HEADER_DESCRIPTION_AUDIO_BLOCK_QUERY}
					}						
					... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_IMAGE_BLOCK} {
						${HEADER_DESCRIPTION_IMAGE_BLOCK_QUERY}
					}						
					... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_SPOT_IMAGE_BLOCK} {
						${HEADER_DESCRIPTION_SPOT_IMAGE_BLOCK_QUERY}
					}						
					... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_ICONS_GRID_BLOCK} {
						${HEADER_DESCRIPTION_ICONS_GRID_BLOCK_QUERY}
					}
					... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_FILES_BLOCK} {
						${HEADER_AND_DESCRIPTION_FILES_BLOCK_QUERY}
					}							
				}
				columnStart
				backgroundColor{
					${COLOR_BLOCK_QUERY}
				}
				${PADDINGS_QUERY}
			}
			...on ${CONTENT_TYPES.IMAGE_WITH_CAPTION} {
				${IMAGE_WITH_CAPTION_QUERY}
			}
			...on ${CONTENT_TYPES.STATS} {
				id
				statistics{
					__typename
					... on ${CONTENT_TYPES.STATISTIC}{
						${STATISTIC_BLOCK_QUERY}
					}
					... on ${CONTENT_TYPES.STATISTIC_GROUP}{
						${STATISTIC_GROUP_BLOCK_QUERY}
					}
				}
				${PADDINGS_QUERY}
			}
			... on ${CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE} {
				${BANNER_CALL_TO_ACTION_QUERY}
			}
			... on  ${CONTENT_TYPES.TILES_MODULE} {
				${TILES_MODULE_QUERY}
			}
			... on ${CONTENT_TYPES.PARALLAX_IMAGE_AND_DESCRIPTION} {
				${PARALLAX_IMAGE_AND_DESCRIPTION_QUERY}
			} 
			... on ${CONTENT_TYPES.TABLE_MODULE} {
				${TABLE_QUERY}
			}
			... on ${CONTENT_TYPES.EXPANDING_LIST_AND_DESCRIPTION} {
				${EXPANDING_LIST_AND_DESCRIPTION_QUERY}
			}
			... on ${CONTENT_TYPES.EXPANDING_LIST_AND_DESCRIPTION} {
				${EXPANDING_LIST_AND_DESCRIPTION_QUERY}
			}
			... on ${CONTENT_TYPES.PARALLAX_SLIDER} {
				${PARALLAX_SLIDER_QUERY}
			}
			... on ${CONTENT_TYPES.VIDEO_WITH_COVER_MODULE} {
				${VIDEO_WITH_COVER_MODULE_QUERY}
			}
			${PARTNERS_QUERY}
			${GLOBAL_BASED_BANNER_QUERY}
			... on ${CONTENT_TYPES.GALLERY_MODULE} {
				${GALLERY_MODULE_QUERY}
			}
			... on ${CONTENT_TYPES.HIGHLIGHTED_HEADING} {
				${HIGHLIGHTED_HEADING_QUERY}
			}
			... on ${CONTENT_TYPES.DESCRIPTION_WITH_IMAGE} {
				${DESCRIPTION_WITH_IMAGE_QUERY}
			}
			... on ${CONTENT_TYPES.PINNED_HISTORY} {
				${PINNED_HISTORY_QUERY}
			}
			... on ${CONTENT_TYPES.GALLERY_DESCRIPTION_TEXT_MODULE} {
				${GALLERY_DESCRIPTION_TEXT_MODULE_QUERY}
			}
			... on ${CONTENT_TYPES.SIGNUP_FORM_MODULE} {
				${SIGNUP_FORM_QUERY}
			}
			... on ${CONTENT_TYPES.TWO_IMAGES_IN_ROW_MODULE} {
				${TWO_IMAGES_IN_ROW_QUERY}
			}
			${EXPANDING_TABS_MODULE_QUERY}
			... on ${CONTENT_TYPES.DONOR_STORIES} {
				${DONOR_STORIES_QUERY}
			}
			... on ${CONTENT_TYPES.BRANCH_NAVIGATOR} {
				${BRANCH_NAVIGATOR_QUERY}
			}
			... on ${CONTENT_TYPES.KRS_BANNER} {
				${KRS_BANNER_QUERY}
			}
			... on ${CONTENT_TYPES.COUNT_DOWN_TIMER_MODULE} {
				${COUNT_DOWN_TIMER_MODULE_QUERY}
			}
			... on ${CONTENT_TYPES.SHARE_MODULE} {
				${SHARE_MODULE_QUERY}
			}
		}
	} 
`

export const RECAP_SUMMARY_ITEM_QUERY_PREVIEW_MODULES = `
	... on ${CONTENT_TYPES.RECAP_SUMMARY_ITEM} {
		id
		item {
			__typename
			${FAQ_PREVIEW_QUERY}
			${GALLERY_PREVIEW_QUERY}
			${TILES_MODULE_PREVIEW_QUERY}
			${HEADER_DESCRIPTION_MODULE_PREVIEW_QUERY}
		}
	} 
`

export const RECAP_SUMMARY_ITEM_MODULES_ORDER_QUERY = `
	... on ${CONTENT_TYPES.RECAP_SUMMARY_ITEM} {
		id
		item {
			__typename 
		}
	} 
`

export const FOOTER_QUERY = ` 
	footer {
		id
		allRightsReservedText
		topRowFeaturedLink {
			${LOCAL_LINK_QUERY}
		}
		topRowLinks {
			${LOCAL_LINK_QUERY}
		}
		iPayButton {
			${BUTTON_BLOCK_QUERY}
		}
		transfers {
			id
			title
			itemCopiedText
			transferCategories {
				id
				title
				items {
					${TRANSFER_QUERY}
				}
			}
		}
		siteMap {
			id
			title
			options {
				__typename
				... on ${CONTENT_TYPES.SITE_MAP_LINKS_GROUP_BLOCK} {
					id
					name
					links {
						label
						${LOCAL_LINK_QUERY}
					}
				}
				... on ${CONTENT_TYPES.SITE_MAP_SINGLE_LINK_BLOCK} {
					link {
						${LOCAL_LINK_QUERY}
					}
				}
			}
		}
		newsletter {
			id
			header
			emailInputPlaceholder
			nameInputPlaceholder
			buttonText
			consent
			modalOkButtonText
			modalCancelButtonText
			modalSuccess {
				${MODAL_CONTENT_QUERY}
			}
			modalEmailTaken {
				${MODAL_CONTENT_QUERY}
			}
			modalError {
				${MODAL_CONTENT_QUERY}
			}
		}
		credits {
			${BUTTON_BLOCK_QUERY}
		}
	}
`

export const PAYMENT_TRANSFERS_QUERY = ` 
	paymentsTransferData {
		id
		transferInfo
		transferInfoDescription
		instructionsText
		transfers {
			id
			title
			itemCopiedText
			transferCategories {
				id
				title
				items {
					${TRANSFER_QUERY}
				}
			}
		}
	}
`

export const COOKIES_QUERY = `
	cookies {
		id
		title
		header
		description
		configButton
		acceptAllButton
		backButton
		saveChosenButton
		generalButton
		generalDescription
		cookiesIcon {
			${IMAGE_QUERY}
		}
		additionalCookies {
			id
			name
			description
			cookieType
		}
	}
`

export const CAREER_MODULE_QUERY = `
	... on ${CONTENT_TYPES.CAREER_MODULE} {
		id
		${PADDINGS_QUERY}
		jobOffers {
			id
			header
			description
			button {
				${BUTTON_BLOCK_QUERY}
			}
		}
	}	
`

export const CHOSEN_NEWS_MODULE_QUERY = `
	id
	${PADDINGS_QUERY}
	headerDescription {
		${HEADER_DESCRIPTION_BLOCK}
	}
	displayFormat
	news { 
		__typename
		_createdAt
		slug
		card {
			${CARD_BLOCK_QUERY}
		}
	}
`

export const NEWS_STRUCTURED_TEXT_QUERY = `
	__typename
	value
	links {
		__typename
		${PAYMENT_MODULE_QUERY}
		... on ${CONTENT_TYPES.SINGLE_PAGE} {
			id
			slug
		}
		... on ${CONTENT_TYPES.NEWS} {
			id
			slug
		}
	}
	blocks {
		__typename 
		... on ${CONTENT_TYPES.MARGIN} {
			${MARGIN_QUERY}
		}
		... on ${CONTENT_TYPES.IMAGE}  {
			id
			showMetaData
			image {
				${IMAGE_QUERY}
				customData
			}
		}
		... on ${CONTENT_TYPES.MEDIUM_IMAGE} {
			id
			showMetaData
			image {
				${IMAGE_QUERY}
				customData
			}
		}
		... on ${CONTENT_TYPES.HIGHLIGHTED_HEADING_AND_DESCRIPTION} {
			id
			header
			description
			backgroundColor {
				${COLOR_BLOCK_QUERY}
			}
		}
		... on ${CONTENT_TYPES.DOWNLOAD_FILES} {
			${DOWNLOAD_FILES_QUERY}
		}
		... on ${CONTENT_TYPES.LARGE_IMAGE} {
			id
			showMetaData
			image {
				${IMAGE_QUERY}
				customData
			}
		} 
		... on ${CONTENT_TYPES.VIDEO} {
			${VIDEO_BLOCK_QUERY}
		}
		... on ${CONTENT_TYPES.GALLERY}  {
			id
			images { 
				${IMAGE_QUERY}
			}
		}
		... on ${CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK}{
			id
			${HEADER_AND_DESCRIPTION_BLOCK_QUERY}
		}

		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_AND_AUDIO_BLOCK} {
			${HEADER_DESCRIPTION_AUDIO_BLOCK_QUERY}
		}
		... on ${CONTENT_TYPES.TABLE_BLOCK} {
			${TABLE_BLOCK_QUERY}
		}
	}
`

export const FACTS_MODULE_QUERY = `
	id
	header
	buttonText
	${PADDINGS_QUERY}
	items {
		id
		__typename
		... on ${CONTENT_TYPES.FACT_PAGE} {
			id
			number
			slug
			pageName
			snippet
			highlighted
		}
	}
`

export const BANNER_TYPOGRAPHY_QUERY = `
	id
	${PADDINGS_QUERY}
	variant
	headerDescription {
		... on ${CONTENT_TYPES.HEADER_DESCRIPTION_BLOCK} {
			${HEADER_DESCRIPTION_BLOCK}
		}
	}
	items {
		__typename
		... on ${CONTENT_TYPES.BANNER_TYPOGRAPHY_ITEM} {
			id
			header
			description
			button {
				${BUTTON_BLOCK_QUERY}
			}
			highlighted
		}
	}
`

export const ARTICLE_QUERY = `
	id
	name
	slug
	content{
		${NEWS_STRUCTURED_TEXT_QUERY}
	}
`

export const EVENT_QUERY = `
		__typename
		id
		name
		start
		end
		allDay
		address
		card{
			${CARD_BLOCK_QUERY}
		}
		state{
			${STATE_QUERY}
		}
		article{
			__typename
			slug
		}
`

export const ARTICLES_LIST_PREVIEW_QUERY = `
	id
	articles: _allReferencingArticles(orderBy: _createdAt_DESC, first: 500) {
		__typename
    	id
    	slug
    	card {
    		${SIMPLE_CARD_BLOCK_QUERY}
    	}
		state {
			${STATE_QUERY}
		}
		_createdAt
    }
    facts: _allReferencingFactPages(orderBy: _createdAt_DESC, first: 500) {
    	__typename
    	id
    	slug
    	card {
    		${SIMPLE_CARD_BLOCK_QUERY}
    	}
    	_createdAt
    }
`

export const SINGLE_PAGE_QUERY = `
	id
	singlePageName
	slug
	pageType
	${SEO_QUERY}
	${CONTEXT_BASED_BANNER_QUERY}
	content {
		__typename
		${GLOBAL_BASED_BANNER_QUERY}
		${CONTACT_FORM_PREVIEW_MODULE_QUERY}
		${FAQ_PREVIEW_QUERY} 
		${PAYMENT_MODULE_QUERY}
		${SOCIAL_MEDIA_FEED_QUERY}
		${STRUCTURED_TEXT_MODULE_QUERY}
		${RULES_TILES}
		${DONOR_STORIES_QUERY}
		${NEWS_THUMBNAIL_HOME}
		${PARTNERS_QUERY}
		${CAREER_MODULE_QUERY} 
		${HEADER_AND_DESCRIPTION_MODULE_QUERY}
		${TABS_AND_IMAGE_PREVIEW_QUERY}
		${TEAM_QUERY}
		${STATES_MAP_QUERY}
		${DRAGGABLE_LETTERS_BANNER_QUERY}
		${EXPANDABLE_VIDEO_QUERY}
		${TEXT_AND_DESCRIPTION_WITH_BUTTON_QUERY}
		${TABLE_PREVIEW_QUERY}
		${EXPANDING_TABS_MODULE_QUERY}
		... on ${CONTENT_TYPES.CALENDAR} {
			id 
			header
			navigationHeader
			initialEvents: _allReferencingEvents(first: 500, filter: {
			  start: {
				gte: "${CALENDAR_RANGE.ISOStart}",
				lt: "${CALENDAR_RANGE.ISOEnd}"
			  }
			}) {
			  ${EVENT_QUERY}
			}
		}
		... on ${CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE} {
			${BANNER_CALL_TO_ACTION_QUERY}
		}
		... on ${CONTENT_TYPES.TABLE_MODULE} {
			${TABLE_QUERY}
		}
		... on ${CONTENT_TYPES.PARALLAX_IMAGE_AND_DESCRIPTION} {
			${PARALLAX_IMAGE_AND_DESCRIPTION_QUERY}
		}
		... on ${CONTENT_TYPES.PARALLAX_SLIDER} {
			${PARALLAX_SLIDER_QUERY}
		}
		...on ${CONTENT_TYPES.STATS} {
			id
			statistics{
				__typename
				... on ${CONTENT_TYPES.STATISTIC}{
					${STATISTIC_BLOCK_QUERY}
				}
				... on ${CONTENT_TYPES.STATISTIC_GROUP}{
					${STATISTIC_GROUP_BLOCK_QUERY}
				}
			}
			${PADDINGS_QUERY}
		}
		... on ${CONTENT_TYPES.EXPANDING_LIST_AND_DESCRIPTION} {
			${EXPANDING_LIST_AND_DESCRIPTION_QUERY}
		}
		...on ${CONTENT_TYPES.IMAGE_WITH_CAPTION} {
			${IMAGE_WITH_CAPTION_QUERY}
		}
		... on ${CONTENT_TYPES.DESCRIPTION_WITH_IMAGE} {
			${DESCRIPTION_WITH_IMAGE_QUERY}
		}
		... on ${CONTENT_TYPES.HIGHLIGHTED_HEADING} {
			${HIGHLIGHTED_HEADING_QUERY}
		}
		... on ${CONTENT_TYPES.GALLERY_MODULE} {
			${GALLERY_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.TILES_MODULE} {
			${TILES_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.PINNED_HISTORY} {
			${PINNED_HISTORY_QUERY}
		}
		... on ${CONTENT_TYPES.COLORFUL_SQUARES_MODULE} {
			${COLORFUL_SQUARES_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.GALLERY_DESCRIPTION_TEXT_MODULE} {
			${GALLERY_DESCRIPTION_TEXT_MODULE_QUERY}	
		}
		... on ${CONTENT_TYPES.ARCHIVE} {
			${ARCHIVE_QUERY}
		}
		... on ${CONTENT_TYPES.PRESS_MEDIA_FEED} {
			${PRESS_MEDIA_FEED_QUERY}
		}
		... on ${CONTENT_TYPES.VIDEO_WITH_COVER_MODULE} {
			${VIDEO_WITH_COVER_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.SIGNUP_FORM_MODULE} {
			${SIGNUP_FORM_QUERY}
		}	
		... on ${CONTENT_TYPES.BRANCH_NAVIGATOR} {
			${BRANCH_NAVIGATOR_QUERY}
		}
		... on ${CONTENT_TYPES.HEADING_GRAPHIC_MODULE} {
			${HEADING_GRAPHIC_MODULE}
		}
		...on ${CONTENT_TYPES.IMAGE_WITH_CAPTION} {
			${IMAGE_WITH_CAPTION_QUERY}
		}
		... on ${CONTENT_TYPES.FACTS_MODULE} {
			${FACTS_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.BANNER_TYPOGRAPHY} {
			${BANNER_TYPOGRAPHY_QUERY}
		}
		... on ${CONTENT_TYPES.CHOSEN_NEWS_MODULE} {
			${CHOSEN_NEWS_MODULE_QUERY}
		}
		... on ${CONTENT_TYPES.KRS_BANNER} {
			${KRS_BANNER_QUERY}
		}
		... on ${CONTENT_TYPES.ARTICLES_LIST_PREVIEW_MODULE} {
			${ARTICLES_LIST_PREVIEW_QUERY}
		}
		... on ${CONTENT_TYPES.SHARE_MODULE} {
			${SHARE_MODULE_QUERY}
		}
	}
`
